import Image from "next/image";
import { Wrench } from "lucide-react";

interface MaintenancePageProps {
  message: string;
}

export function MaintenancePage({ message }: MaintenancePageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50 px-4">
      <div className="w-full max-w-md text-center">
        <Image src="/xd-logo-blue.svg" alt="Sjálfstæðisflokkurinn" width={98} height={66} unoptimized className="h-12 w-auto mx-auto mb-8" />

        <div className="bg-card border border-border p-8">
          <div className="flex justify-center mb-4">
            <Wrench className="w-10 h-10 text-muted-foreground" />
          </div>
          <h1 className="text-xl font-heading font-bold text-foreground mb-3">
            Viðhaldsvinna stendur yfir
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {message || "Reyndu aftur síðar."}
          </p>
        </div>
      </div>
    </div>
  );
}
